import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { Outlet } from 'react-router';

const queryClientNoCache = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 0,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const QueryProviderNoCache = () => {
  return (
    <QueryClientProvider client={queryClientNoCache}>
      <Outlet />
    </QueryClientProvider>
  );
};

export default QueryProviderNoCache;
